export default __webpack_public_path__ + "static/media/fingerpaint-regular-webfont.564d2e84.ttf";